import { useTranslation } from "react-i18next";

// Inline bilingual strings: L("Bonjour", "Hello") picks the active UI language.
export function useL() {
  const { i18n } = useTranslation();
  const en = (i18n.resolvedLanguage || i18n.language || "fr").startsWith("en");
  return (fr, enText) => (en ? enText : fr);
}
